import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import DatePicker from 'react-datepicker';
import getLocale from '../../i18n/getLocale';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class FlightReportRefuelsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      selected_date: '',
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();

    this.export_caribbean_receipt = this.export_caribbean_receipt.bind(this);
    this.export_receipt = this.export_receipt.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleChangeDate (name, event) {
    var change = {};
    var full_date = this.state.date_start;
    if(event == null) {
      change[name] = null;
    } else {
      var date = event.target.value;
      var year  = date.split("-")[0];
      var month  = date.split("-")[1];
      var day  = date.split("-")[2];
      // Utilizo o .slice(-2) para garantir o formato com 2 dígitos.
      var full_date = ("0"+day).slice(-2) + "/" + ("0"+month).slice(-2) + "/" + year;
      change[name] = date;
    }
    this.setState(change);
    this.loadData(full_date);
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      var now = new Date();
      var month = (now.getMonth()) + 1;
      var year = now.getFullYear();
      var day = now.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      var reference = day + '/' + month + '/' + year;
      this.setState({loaded: 2}, this.loadData(reference));
    }
  }

  componentWillMount () {
    var today = new Date();
    var date = today.setDate(today.getDate());
    var today_str = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd

    this.setState({date_start: today_str});
  }

  loadData(reference) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/abastecimentos/' + reference, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  export_caribbean_receipt(id) {
    var self = this;
    var url = "/relatorio/voo/abastecimento/caribbean/exportar/";
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
        self.handleAlert('', '', 'closed');
      });
    });
  }

  export_receipt(cell, row) {
    if (row.file === null) {
      return;
    }
    var url = '/files/refuels/' + cell + '_' + row.file;
    window.open(config.get('cdn') + url);
  }

  delete (id) {
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse abastecimento?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/abastecimento', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteRow(id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }

  ActionsButtons (cell, row) {
    var url = '/abastecimento/editar/' + cell;

    var botao = (
      <div className="btn-group">
          <Link className={'btn btn-primary btn-sm button-inline'} to={url}>
            <i className="fa fa-fw fa-pencil"></i>
          </Link>
          <button className="btn btn-success btn-sm button-inline" onClick={() => this.export_receipt(cell, row)}><i className="fa fa-fw fa-download"></i></button>
          <button className="btn btn-danger btn-sm button-inline" onClick={() => this.delete(cell)}><i className="fa fa-fw fa-trash"></i></button>
      </div>
    );

    return botao;
  }

  next() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.next);
  }

  previous() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.previous);
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <div className="row">
        <div className="col-xs-3">
          <button className="btn btn-primary" onClick={this.previous}><i className="fa fa-fw fa-chevron-left"></i> <span className="hidden-sm hidden-xs">{this.state.previous}</span></button>
        </div>
        <div className="col-xs-6">
          <h3 className="page-title text-center">{this.state.current}</h3>
        </div>
        <div className="col-xs-3 text-right">
          <button className="btn btn-primary" onClick={this.next}><span className="hidden-sm hidden-xs">{this.state.next}</span> <i className="fa fa-fw fa-chevron-right"></i></button>
        </div>
      </div>
      <hr/>
      <h3 className="page-title pull-left">{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.lista}</h3>
      <Link to="/abastecimento/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> {this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.adicionar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <div className="clearfix"></div>
      <div className="row">
        <div className="col-md-2 col-md-offset-5">
          <div className="form-group">
            <input type="date" value={this.state.date_start} onChange={this.handleChangeDate.bind(this, 'date_start')} className="form-control" />
          </div>
        </div>
      </div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.general.semDados}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='60'>ID</TableHeaderColumn>

        <TableHeaderColumn dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Data}</TableHeaderColumn>
        <TableHeaderColumn dataField="flight_report_id" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='140'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Relatório}</TableHeaderColumn>
        <TableHeaderColumn dataField="flight_number" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Voo}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft_registration" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Aeronave}</TableHeaderColumn>
        <TableHeaderColumn dataField="fuel_supplier_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Fornecedor}</TableHeaderColumn>
        <TableHeaderColumn dataField="location_icao_code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Localidade}</TableHeaderColumn>
        <TableHeaderColumn dataField="quantity" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Quantidade}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='200'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportRefuelsIndex;



// WEBPACK FOOTER //
// ./src/Components/FlightReportRefuels/FlightReportRefuelsIndex.js